import $api from '../../utils/api.js'
import moment from 'moment'

const state = () => ({
    all_events: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    events: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 1
    },
    events_type:[
        {label:"Wedding",value:"Wedding"},
        {label:"Birthday",value:"Birthday"},
        {label:"Aniversary",value:"Aniversary"},
        {label:"Yearbook",value:"yearbook"},
    ],
    sorting: {
        num:10,
        search: '',
        offset: 4,
        placeholder:'Search Event Or ID'
    },
    sorting_all_event: {
        num:20,
        search: '',
        offset: 4,
        placeholder:'Search Event Or ID'
    },
    detail_event:{},
    themes:[],
    partner:[],
    opening_style:[],
    cover_style:[],
    cover_position:[],
    person_style:[],
    schedule_style:[],
    gallery_style:[],
    menu_style_md:[],
    music:[],
    filteredMusics: null,
    header_script:null,
    footer_script:null,
    errors:[],
    formevent:{
        title:'',
        date: moment().format("YYYY-MM-DD") + "T00:00:00.000Z",
        package:'STANDARD'

    },
    formcatperson:{
        id:'',
        name:'',
    },
    formperson:{
        id:'',
        id_category:'',
        name:'',
        mother:'',
        father:'',
        address:'',
        type:'',
        sosmed:'',
        photo:''
    },
    formschedule:{
        id:'',
        name:'',
        location:'',
        is_multi:'false',
        link_location:'',
        frame_location:'',
        time_start:'',
        time_end:'',
        time_zone:'',
        date:'',
        cover:'',
    },
    formstory:{
        id:'',
        title:'',
        desc:'',
        photo:'',
    },
    formpaymod:{
        id:'',
        type:'',
        payment_name:'',
        acc_name:'',
        number:'',
        photo:'',
    },
    formcatgallery:{
        id:'',
        name:'',
    },
    formgallery:{
        id_category:'',
    },
    progressBarUpload:0,
})

const getters = {
    getFilteredMusics: (state) => state.filteredMusics ? state.filteredMusics : state.music,
}

const mutations = {
    ASSIGN_DATA_ALL_EVENTS(state, payload) {
        state.all_events = payload
    },
    ASSIGN_DATA(state, payload) {
        state.events = payload
    },
    ASSIGN_DETAIL_EVENT(state, payload) {
        state.detail_event = payload
        state.music = payload.music
        state.themes = payload.themes
        state.partner = payload.partner
        state.opening_style = payload.opening_style_md
        state.cover_style = payload.cover_style_md
        state.cover_position = payload.cover_position_md
        state.person_style = payload.person_style_md
        state.schedule_style = payload.schedule_style_md
        state.gallery_style = payload.gallery_style_md
        state.menu_style_md = payload.menu_style_md
    },
    FILTERED_MUSICS(state, filter) {
        var search = filter.trim().toLowerCase()
        state.filteredMusics = state.music.filter((music) => {
            return music.title.toLowerCase().includes(search) 
        })
    },
    CLEAR_EVENTS(state){
        state.events = {
            total: 0,
            per_page: 2,
            from: 1,
            to: 0,
            current_page: 1
        }
    },
    SET_ERRORS(state, payload) {
        state.errors = payload
    },
    CLEAR_DETAIL_EVENT(state) {
        state.detail_event = {}
    },

    // CATEGORY PERSON
    ////////////

    SET_POSITION_CATPERSON(state, payload) {
        state.detail_event.catperson = payload
    },
    ASSIGN_FORM_CATPERSON(state, payload){
        state.formcatperson = {
            id:payload.id,
            name:payload.name,
        }
    },
    CLEAR_FORM_CATPERSON(state){
        state.formcatperson = {
            id:'',
            name:'',
        }
    },

    // PERSON
    ////////////
    SET_POSITION_PERSONS(state, payload) {
        state.detail_event.persons = payload
    },
    ASSIGN_FORM_PERSON(state, payload){
        state.formperson = {
            id:payload.id,
            id_category:payload.category_id,
            name:payload.name,
            mother:payload.mother,
            address:payload.address,
            father:payload.father,
            type:payload.type,
            photo:payload.photo,
            sosmed:payload.sosmed,
        }
    },
    CLEAR_FORM_PERSON(state){
        state.formperson = {
            id:'',
            id_category:'',
            name:'',
            mother:'',
            father:'',
            address:'',
            type:'',
            photo:'',
            sosmed:'',
        }
    },

    // Schedule
    ////////////

    SET_POSITION_SCHEDULE(state, payload) {
        state.detail_event.schedule = payload
    },
    ASSIGN_FORM_SCHEDULE(state, payload){
        state.formschedule = {
            id:payload.id,
            name:payload.name,
            location:payload.location,
            link_location:payload.link_location,
            is_multi:payload.is_multi,
            frame_location:payload.frame_location,
            time_start:payload.time_start,
            time_end:payload.time_end,
            time_zone:payload.time_zone,
            date:payload.date,
            cover:payload.cover,
        }
    },
    CLEAR_FORM_SCHEDULE(state){
        state.formschedule = {
            id:'',
            name:'',
            location:'',
            link_location:'',
            is_multi:'false',
            frame_location:'',
            time_start:'',
            time_end:'',
            time_zone:'',
            date:'',
            cover:'',
        }
    },

    // CATEGORY GALLERY
    ////////////

    SET_POSITION_CATGALLERY(state, payload) {
        state.detail_event.catgallery = payload
    },
    ASSIGN_FORM_CATGALLERY(state, payload){
        state.formcatgallery = {
            id:payload.id,
            name:payload.name,
        }
    },
    CLEAR_FORM_CATGALLERY(state){
        state.formcatgallery = {
            id:'',
            name:'',
        }
    },

    // GALLERY
    ////////////

    CLEAR_FORM_GALLERY(state){
        state.formgallery = {
            id_category:'',
        },
        state.progressBarUpload = 0
    },


    // STORY
    ////////////
    SET_POSITION_STORY(state, payload) {
        state.detail_event.story = payload
    },
    ASSIGN_FORM_STORY(state, payload){
        state.formstory = {
            id:payload.id,
            title:payload.title,
            desc:payload.desc,
            photo:payload.photo,
        }
    },
    CLEAR_FORM_STORY(state){
        state.formstory = {
            id:'',
            title:'',
            desc:'',
            photo:'',
        }
    },

    // PAYMENT METHOD
    ////////////

    SET_POSITION_PAYMOD(state, payload) {
        state.detail_event.paymentmethod = payload
    },
    ASSIGN_FORM_PAYMOD(state, payload){
        state.formpaymod = {
            id:payload.id,
            type:payload.type,
            payment_name:payload.payment_name,
            acc_name:payload.acc_name,
            number:payload.number,
            photo:payload.photo,
        }
    },
    CLEAR_FORM_PAYMOD(state){
        state.formpaymod = {
            id:'',
            type:'',
            payment_name:'',
            acc_name:'',
            number:'',
            photo:'',
        }
    },
}

const actions = {
    filterMusics({ commit }, word) {
        commit('FILTERED_MUSICS', word)
    },
    getAllEvents({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`all-events?page=${state.events.current_page}&paginate=${state.sorting_all_event.num}&search=${state.sorting_all_event.search}`)
            .then((response) => {
                commit('ASSIGN_DATA_ALL_EVENTS', response.data)
                resolve(response.data)
            })
        })
    },
    getEvents({ commit, state }) {
        return new Promise((resolve) => {
            $api.get(`events?page=${state.events.current_page}&paginate=${state.sorting.num}&search=${state.sorting.search}`)
            .then((response) => {
                commit('ASSIGN_DATA', response.data)
                resolve(response.data)
            })
        })
    },
    createEvents({ commit,state }) {
        return new Promise((resolve,reject) => {
            $api.post(`events`, state.formevent)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    generateQREvents({ commit,state }) {
        return new Promise((resolve,reject) => {
            $api.put(`generateqrcode`, {id:state.detail_event.id,slug:state.detail_event.slug})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    deleteEvents({ dispatch }, payload) {
        return new Promise((resolve,reject) => {
            $api.delete(`events/${payload}`)
            .then(() => {
                dispatch('getEvents').then(() => resolve())
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    detailEvents({ commit }, payload) {
        return new Promise((resolve) => {
            $api.get(`events/${payload}`)
            .then((response) => {
                commit('ASSIGN_DETAIL_EVENT', response.data)
                resolve(response.data)
            })
        })
    },
    changeStatusEvent({ commit }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`status/events`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },

    //THEME SETUP
    changeTheme({ state,commit }, payload) {
        return new Promise((resolve) => {
            $api.put(`event/theme/${payload}`, state.detail_event)
            .then((response) => {
                state.detail_event.theme_id = payload
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
            })
        })
    },

    //BASIC SETUP
    updateBasicSetup({ commit,state }, payload) {
        return new Promise((resolve, reject) => {
            $api.post(`event/basic/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                if (error.response.status == 400) {
                    commit('SET_ERRORS', error.response.data.errors)
                }
                reject(error)
            })
        })
    },
    changeWording({ state }, payload) {
        return new Promise((resolve) => {
            $api.put(`event/wording/${state.detail_event.id}`, {lang:payload})
            .then((response) => {
                resolve(response.data)
            })
        })
    },
    upgradePackage({ state }) {
        return new Promise((resolve,reject) => {
            $api.put(`event/upgrade/${state.detail_event.id}`)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //CATPERSON

    createCatPerson({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/catperson/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateCatPerson({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/catperson/${state.formcatperson.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteCatPerson(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/catperson/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionCatPerson({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/catperson/${state.detail_event.id}`, {catperson:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //PERSON

    createPersons({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/persons/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePersons({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/persons/${state.formperson.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deletePerson(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/persons/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionPerson({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/persons/${state.detail_event.id}`, {person:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //SCHEDULE
    createSchedule({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/schedule/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateSchedule({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/schedule/${state.formschedule.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteSchedule(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/schedule/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionSchedule({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/schedule/${state.detail_event.id}`, {schedule:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //CATGALLERY

    createCatGallery({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/catgallery/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateCatGallery({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/catgallery/${state.formcatgallery.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteCatGallery(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/catgallery/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionCatGallery({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/catgallery/${state.detail_event.id}`, {catgallery:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //GALLERY
    createGallery({ state }, payload) {
        return new Promise((resolve,reject) => {
            setTimeout(() => {
                $api.post(`event/gallery/${state.formgallery.id_category}/${state.detail_event.id}`, payload, {
                    onUploadProgress: function( progressEvent ) {
                        state.progressBarUpload = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100))
                    }.bind(this)
                })
                .then((response) => {
                    resolve(response.data)
                })
                .catch((error) => {
                    reject(error)
                })
            }, 2000)
        })
    },
    updateGallery({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/gallery/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionGallery({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/gallery/${state.detail_event.id}`, {gallery:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteGallery(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/gallery/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    //STORY
    createStory({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/story/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updateStory({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/story/${state.formstory.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deleteStory(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/story/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionStory({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/story/${state.detail_event.id}`, {story:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

     //PAYMENT METHOD
     createPaymod({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/paymod/${state.detail_event.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePaymod({ state }, payload) {
        return new Promise((resolve,reject) => {
            $api.post(`event/paymod/${state.formpaymod.id}`, payload)
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    deletePaymod(_, payload) {
        return new Promise((reject) => {
            $api.delete(`event/paymod/${payload}`)
            .then(() => {
            })
            .catch((error) => {
                reject(error)
            })
        })
    },
    updatePositionPaymod({state}, payload) {
        return new Promise((resolve,reject) => {
            $api.put(`event/position/paymod/${state.detail_event.id}`, {paymod:payload})
            .then((response) => {
                resolve(response.data)
            })
            .catch((error) => {
                reject(error)
            })
        })
    },

    // GUESTBOOK MESSAGE
    deleteGuesbookMessage(_, payload) {
        return new Promise((resolve) => {
            $api.delete(`event/message/${payload}`)
            .then((response) => {
                resolve(response.data)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
